import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { InviteMemberTemplate } from 'components/Templates'

const InviteMember: FC = () => {
  return (
    <Layout headline={'店舗アカウント設定'} iconPath={'/icon/white/setting.svg'} title={'メンバーを招待'}>
      <InviteMemberTemplate />
    </Layout>
  )
}

export default InviteMember
